import { Outlet } from '@tanstack/react-router';

import { AppHeader } from '@/router/components/AppHeader';

export function BaseLayout() {
  return (
    <div>
      <AppHeader />
      <main className="mx-auto max-w-[892px]">
        <div className="mx-4 mb-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
